import {onDomReady} from "../../components/dynamic/observer";

class Quiz {
  constructor(container) {
    this.container = container;
    this.options = {
      contactFormSent: false,
    };
    this.state = {
      quizId: null,
      questions: [],
      contactFormSent: false,
    };
    this.initSlides();
    // this.nextSlide();
  }

  getState() {
    return this.state;
  }

  setState(state) {
    this.state = state;
  }

  getStateQuestionsIds() {
    return this.state.questions.map(question => question.questionId);
  }

  getStateAnswers() {
    const stateAnswers = [];
    this.state.questions.forEach((question) => {
      question.answers.forEach(answerId => stateAnswers.push(answerId));
    });
    return stateAnswers;
  }

  pushStateQuestion(question) {
    this.state.questions.push(question);
  }

  setStateQuizId(quizId) {
    this.state.quizId = quizId;
  }

  setStateContactForm(bool) {
    this.state.contactForm = bool;
  }

  getStateContactForm() {
    return this.state.contactForm;
  }

  initSlides() {
    // - initSlides() - обходим все формы в слайдах в квизе, чтобы обрабатывать пользовательский ввод и подписываемся
    // - submit `[data-question-id] form` -> `onSlideSubmit(formEl)`
    // - submit `[data-quiz-contact-form]` -> `onSubmitContactForm(formEl)`
    const quizId = parseInt(this.container.dataset.quiz, 10);
    this.setStateQuizId(quizId);

    this.nextSlide();

    const questionForms = this.container.querySelectorAll('[data-question-id] form');
    questionForms.forEach((questionForm) => {
      const prevButton = questionForm.querySelector('[data-prev-button]');
      if (prevButton) {
        prevButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.prevSlide(e.target);
        });
      }
      questionForm.addEventListener('submit', (e) => {
        e.preventDefault();
        this.onSlideSubmit(questionForm);
      });
    });

    document.addEventListener('quiz-form-sent', (e) => {
      this.onSubmitContactForm(e.detail.form);
    });
  }

  onSubmitContactForm(formEl) {
    // радем кусок обработки ajax-form, при успешной отправке формы вызываем `setStateContactForm(true)`, затем `nextSlide()`
    this.setStateContactForm(true);
    this.nextSlide();
  }

  onSlideSubmit(formEl) {
    // - тут валидируем что пользователь выбрал вариант (если таковые ему предоставлены) или заполнил поля (опять же если они есть)
    // - если что-то не верно - показываем это безобразие в `[data-form-error]` этого слайда
    // - если все заполнено верно, сохраняем выбранное значение `pushStateQuestion({questionId: ИД, answers: ОТВЕТЫ})`
    this.cleanErrors(formEl);
    let hasErrors = false;
    let answersInputs = null;
    const { questionId } = formEl.closest('[data-question-id]').dataset;
    const answersContainer = formEl.querySelector('[data-question-variants]');
    if (answersContainer) {
      answersInputs = answersContainer.querySelectorAll('input');
    }
    const answers = [];
    if (answersInputs) {
      answersInputs.forEach((answersInput) => {
        if (answersInput.checked) {
          answers.push(
            parseInt(answersInput.value, 10),
          );
        }
      });
    }

    if (answersInputs && answers.length <= 0) {
      hasErrors = true;
      this.addErrors(formEl, 'Выберите хотя бы один вариант ответа');
    }

    if (hasErrors) {
      return false;
    }

    this.pushStateQuestion({
      questionId: parseInt(questionId, 10),
      answers,
    });

    this.nextSlide();
  }

  nextSlide() {
    this.showSlide(this.findNextSlide());
  }

  prevSlide(prevButton) {
    const questionId = parseInt(prevButton.dataset.prevButton, 10);
    if (this.findPrevQuestionSlide(questionId)) {
      this.showSlide(this.findPrevQuestionSlide(questionId));
    }
  }

  showSlide(element) {
    const slides = this.container.querySelectorAll('.quiz-slide');
    slides.forEach((slide) => {
      slide.style.display = 'none';
    });
    element.style.display = 'flex';
  }

  findNextSlide() {
    const questionSlide = this.findNextQuestionSlide();
    if (questionSlide) {
      return questionSlide;
    }

    // - если вопросов по такому алгоритму не нашлось - смотрим на contactFormSent
    if (this.getStateContactForm()) {
      // - если contactFormSent=true, то ищем слайд финала (только уже 1) по похожей схеме с поиском слайда вопроса и выдаем его
      const finalSlide = this.findFinalSlide();
      if (finalSlide) {
        return finalSlide;
      }
    }

    // - если contactFormSent=false, то выдаем слайд с формой
    const form = this.container.querySelector('[data-quiz-form]');
    const formAnswerField = form.querySelector('input[name="quiz_lead[answersData]"]');
    // Записываем JSON.stringify(state) в поле answers_data
    formAnswerField.value = JSON.stringify(this.state);
    return form;
  }

  findFinalSlide() {
    const finalSlides = this.container.querySelector('[data-final]');

    if (finalSlides) {
      return finalSlides;
    }

    return null;
  }

  findNextQuestionSlide() {
    const questionSlides = this.container.querySelectorAll('[data-question-id]');
    let foundQuestionSlide = null;
    questionSlides.forEach((slide) => {
      if (foundQuestionSlide) {
        return;
      }
      const { questionId } = slide.dataset;

      const stateQuestions = this.getStateQuestionsIds();
      // 2. Мы не задавали этот вопрос - его ID нет в `getStateQuestions()`
      if (stateQuestions.includes(parseInt(questionId, 10))) {
        return;
      }

      // if (slideIfs.length <= 0) {
        foundQuestionSlide = slide;
        // return;
      // }

      // // intersect slideIfs and this.getStateAnswers()
      // const answers = this.getStateAnswers();
      // const intersection = slideIfs.filter(value => answers.includes(value));
      //
      // // 3. Если у слайда есть data-slide-if - и хотя бы одно значение из data-slide-if есть в `getStateAnswers()`
      // if (intersection.length > 0) {
      //   foundQuestionSlide = slide;
      //   return;
      // }
    });

    if (foundQuestionSlide) {
      return foundQuestionSlide;
    }
  }

  findPrevQuestionSlide(questionId) {
    const questions = this.getQuestionSlides();
    const currentSlideIndex = this.getCurrentSlideIndex(questionId);

    if (currentSlideIndex === null) {
      return null;
    }

    if (this.getStateQuestionsIds().includes(questionId)) {
      this.state.questions.splice((this.getStateQuestionsIds().indexOf(questionId) - 1), 2);
    }

    return questions[currentSlideIndex - 1];
  }

  cleanErrors(slideEl) {
    const errorEl = slideEl.querySelector('[data-form-error]');
    errorEl.innerHTML = '';
  }

  addErrors(slideEl, error) {
    const errorEl = slideEl.querySelector('[data-form-error]');
    const div = document.createElement('div');
    div.innerHTML = error;
    errorEl.appendChild(div);
  }

  findCurrentQuestion() {
    const questions = this.getQuestionSlides();

    let currentQuestion = null;

    questions.forEach((question) => {
      const style = question.getAttribute('style');
      if (style === 'display: flex;') {
        currentQuestion = question;
      }
      return null;
    });

    return currentQuestion;
  }

  getQuestionSlides() {
    return this.container.querySelectorAll('.quiz-slide_question');
  }

  getCurrentSlideIndex(questionId) {
    const questions = this.getQuestionSlides();
    let currentSlideIndex = null;
    let currentSlideId = null;

    if (!questionId) {
      if (this.findCurrentQuestion()) {
        currentSlideId = parseInt(this.findCurrentQuestion().dataset.questionId, 10);
      }
    }

    if (questionId) {
      currentSlideId = parseInt(questionId, 10);
    }

    questions.forEach((question, key) => {
      if (parseInt(question.dataset.questionId, 10) === currentSlideId) {
        currentSlideIndex = key;
      }
    });

    return currentSlideIndex;
  }
}

const bind = () => {
  const container = document.querySelector('[data-quiz]');
  if (container) {
    new Quiz(container);
  }
};

onDomReady(() => {
  bind();
})